(function() {
  var ns = window.nspace("ccc.viz.util");

  ns.UrlParams = {
    timeFrame: "tf",
    indicator: "ind",
    characteristic: "ch",
    locationType: "loct",
    location: "loc",
    category: "cat",
    dataFormat: "fmt",

    filterString: "fs",
    themeColors: "theme"
  };
})();
